import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { findDefaultOptionValue, hasOrientationType } from 'components/consumer/PDP/helpers/pdpOptionUtils';
const usePDPOptionsOrientationIds = t0 => {
  const $ = _c(9);
  const {
    productOptions
  } = t0;
  let t1;
  bb0: {
    if (!productOptions) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== productOptions) {
      t2 = productOptions.map(_temp).find(hasOrientationType);
      $[1] = productOptions;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const orientationOptionId = t2;
    let t3;
    if ($[3] !== orientationOptionId || $[4] !== productOptions) {
      t3 = orientationOptionId ? findDefaultOptionValue(productOptions.find(opt => parseInt(opt.id, 10) === parseInt(orientationOptionId, 10))) : null;
      $[3] = orientationOptionId;
      $[4] = productOptions;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const orientationOptionValueId = t3;
    let t4;
    if ($[6] !== orientationOptionId || $[7] !== orientationOptionValueId) {
      t4 = {
        orientationOptionId,
        orientationOptionValueId
      };
      $[6] = orientationOptionId;
      $[7] = orientationOptionValueId;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t1 = t4;
  }
  return t1;
};
export default usePDPOptionsOrientationIds;
function _temp(t0) {
  const {
    id: sId
  } = t0;
  return sId;
}